<template>
  <div class="container-fluid login">
    <div class="container">
      <div class="row">
        <div id="fondo" :style="'background:url('+ loginImage + ')'  "></div>
        <div class="col-lg-4 col-10 col-sm-8 mx-auto login-form" :class="isBatericars ? 'col-lg-6' : 'col-lg-4'">
          <h2 class="text-center logo_h2">
            <img :src="logo" alt="Logo" class="logo" :class="classNameLogo">
          </h2>
          <!--<div v-if="status !== ''" style="color: red">{{ status }}</div>-->
          <div class="card-body">
            <div class="row" style="display: flex;justify-content: center;">
              <div :class="isBatericars ? 'col-10' : 'col-12'">
                <form @submit.prevent="validateForm()" data-vv-scope="form">
                  <div class="row">
                    <div class="col-sm-12 mt-3 ">
                      <div class="form-group"
                           v-bind:class="errors.has('form.email') ? 'form-group-error': ''"
                      >
                        <input required autofocus
                               placeholder="Correo electŕonico"
                               v-model="auth.email"
                               name="email"
                               type="email"
                               class="form-control"
                               v-validate="'required|email'"
                               data-vv-as=" "
                        />
                        <i class="text-danger icon-error"/>
                        <span class="text-danger span-error" v-text="errors.first('form.email')"/>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <div class="form-group"
                           v-bind:class="errors.has('form.password') ? 'form-group-error': ''"
                      >
                        <input required
                               placeholder="Contraseña"
                               v-model="auth.password"
                               name="password"
                               type="password"
                               class="form-control"
                               v-validate="'required|max:15|min:3'"
                               data-vv-as=" "
                               autocomplete="off"
                        />
                        <i class="text-danger icon-error"></i>
                        <span class="text-danger span-error" v-text="errors.first('form.password')"/>
                      </div>
                    </div>
                    <input type="submit" value="Ingresar"
                           class="btn btn-primary btn-block mb-3 button-p"
                    />
                    <div class="col-sm-12">
                      <router-link to="/olvide/contrasena" class="float-left" exact>
                        ¿Olvido su contraseña?
                      </router-link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import {mapActions, mapState} from 'vuex';
  import {getLogoSubscriber, getIdentificationSubscriber} from '../../util/domains';

  export default {
    name: "login",
    data() {
      return {
        loginImg: [
          '/images/pages/login/1.jpg',
          '/images/pages/login/2.jpg',
          '/images/pages/login/3.jpg',
          '/images/pages/login/4.jpg',
          '/images/pages/login/5.jpg',
          '/images/pages/login/6.jpg',
          '/images/pages/login/7.jpg'
        ],
        loginImage: null,
        logo: getLogoSubscriber()
      }
    },
    created() {
      let random = Math.floor(Math.random() * this.loginImg.length);
      this.loginImage = this.loginImg[random];
    },
    methods: {
      validateForm() {
        this.$validator.validateAll('form').then(async (result) => {
          if (result) {
            await this.authentication().then(async () => {
              const user = JSON.parse(localStorage.user);
              if (user.subscriber ) {
                const textWithoutSpaces = user.subscriber.name.replace(/\s/g, '').toLowerCase();
                if (textWithoutSpaces === 'menu3sas' && user.role === 'CLIENTE') {
                  return this.$router.push("/reportes/informe-de-consumos")
                }
              }

              if (['e', 'p'].includes(this.logued_type)) {
                this.$router.push("/inicio")
              } else if (this.logued_type === 'c') {
                await this.fetchUserB2b().then(() => {
                  this.$router.push("/b2b/inicio")
                })
              }
            })
          }
        });
      },
      ...mapActions('login', [
        'authentication',
        'fetchUserB2b'
      ]),
    },
    computed: {
      ...mapState('login', [
        'auth',
        'user',
        'status',
        'logued_type'
      ]),
      classNameLogo() {

        let classSize;

        const identificationSubscriber = getIdentificationSubscriber()
        switch (identificationSubscriber){
            case  '900266427' : classSize = "home_logo_lugor"; break
            case  '800249945' : classSize = "home_logo_hys"; break
            case  '123456789' : classSize = "home_logo_la_rueda"; break
            case  '901666689' : classSize = "home_logo_vw"; break
            case  '900245118' : classSize = "home_logo_menu3"; break
            case  '800198348' : classSize = "home_logo_ventas_inst"; break
            case  '830508200' : classSize = "home_logo_isla"; break
            case  '90097354' : classSize = "home_logo_batericars"; break
            case  '900646266' : classSize = "home_logo_u2"; break

        }

        return classSize;

      },
      isBatericars() {
        const identificationSubscriber = getIdentificationSubscriber()
        return identificationSubscriber === '90097354'
      }
    }
  }
</script>
<style src="../../assets/css/login.css" scoped></style>
<style type="text/css" scoped>
  .login {
    padding-top: 6.5%;
    padding-bottom: 2%;
    width: 100%;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    overflow-y: auto;
  }

  #fondo {
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    background-size: cover !important;
    height: 100% !important;
  }

  .text-danger {
    font-size: 12px !important;
  }

  .logo {
    margin: 20px 0px 0 0px;
    width: 200px
  }
  
  .home_logo_batericars {
    width: 500px !important;
  }

  .button-p {
    background-color: rgb(28, 33, 117) !important;
    border: 1px solid rgb(28, 33, 117) !important;
  }

  .button-p:hover {
    background-color: rgb(20, 46, 129) !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/login.vue